// forwardErrorsToLogs also records throws from the third-party scripts in
// public/index.html. Keep a log when our own bundle is on the stack, so an
// error inside our callback still reaches Datadog.
const THIRD_PARTY_HOST_SUFFIXES = [
  'pendo.io',
  'posthog.com',
  'hubspot.com',
  'hs-scripts.com',
  'hs-analytics.net',
  'hs-banner.com',
  'hscollectedforms.net',
  'hsappstatic.net',
  'hsadspixel.net',
  'hsforms.net',
  'usemessages.com',
  'fullstory.com',
  'facebook.net',
  'facebook.com',
  'googletagmanager.com',
  'google-analytics.com',
  'clarity.ms',
  'ipify.org',
  'stripe.com',
  'googleapis.com',
  'maps.google.com'
];

const EXTENSION_PROTOCOLS = [
  'chrome-extension:',
  'moz-extension:',
  'safari-extension:',
  'safari-web-extension:',
  'webkit-masked-url:'
];

const URL_PATTERN = /(?:https?:\/\/|chrome-extension:\/\/|moz-extension:\/\/|safari-extension:\/\/|safari-web-extension:\/\/|webkit-masked-url:\/\/)[^\s)'"]+/g;

const isThirdPartyHostname = (hostname) =>
  THIRD_PARTY_HOST_SUFFIXES.some(
    (suffix) => hostname === suffix || hostname.endsWith(`.${suffix}`)
  );

const shouldForwardDatadogLog = (log) => {
  if (log?.origin === 'logger') return true;

  const stack = log?.error?.stack || '';
  const message = typeof log?.message === 'string' ? log.message : '';
  const httpUrl = log?.http?.url || '';
  // Network logs store the response body in error.stack, not a stack trace.
  const text =
    log?.origin === 'network'
      ? `${message}\n${httpUrl}`
      : `${stack}\n${message}`;

  const pageOrigin = window.location.origin;
  const urls = text.match(URL_PATTERN) || [];

  let sawThirdParty = false;
  let sawOwnPage = false;

  urls.forEach((raw) => {
    let parsed;
    try {
      parsed = new URL(raw);
    } catch (error) {
      return;
    }

    if (EXTENSION_PROTOCOLS.includes(parsed.protocol)) {
      sawThirdParty = true;
      return;
    }

    if (parsed.origin === pageOrigin) {
      sawOwnPage = true;
      return;
    }

    if (isThirdPartyHostname(parsed.hostname)) {
      sawThirdParty = true;
    }
  });

  if (sawThirdParty && !sawOwnPage) return false;

  // Cross-origin scripts are reported as "Script error." with no file URL.
  if (
    log?.origin === 'source' &&
    /Script error\.?/.test(message) &&
    !sawOwnPage
  ) {
    return false;
  }

  return true;
};

export default shouldForwardDatadogLog;
